module.exports = __webpack_public_path__ + "static/media/back.d091f9c9.svg";